import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, change, changeType, icon, color = 'primary', hidePercentage = false }) => {
  const getColorClasses = (colorType) => {
    const colors = {
      primary: 'bg-primary text-primary-foreground',
      success: 'bg-success text-success-foreground',
      warning: 'bg-warning text-warning-foreground',
      error: 'bg-error text-error-foreground',
      secondary: 'bg-secondary text-secondary-foreground'
    };
    return colors?.[colorType] || colors?.primary;
  };

  const getChangeColor = (type) => {
    if (type === 'increase') return 'text-green-600';
    if (type === 'decrease') return 'text-red-600';
    if (type === 'new') return 'text-blue-600';
    return 'text-gray-500';
  };

  const getChangeIcon = (type) => {
    if (type === 'increase') return 'TrendingUp';
    if (type === 'decrease') return 'TrendingDown';
    if (type === 'new') return 'Sparkles';
    return 'Minus';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
          <p className="text-2xl font-bold text-foreground mt-1">{value}</p>
          {change && !hidePercentage && (
            <div className="flex items-center mt-2">
              <Icon 
                name={getChangeIcon(changeType)} 
                size={16} 
                className={getChangeColor(changeType)}
              />
              <span className={`text-sm ml-1 font-medium ${getChangeColor(changeType)}`}>
                {change}
              </span>
            </div>
          )}
          {change && hidePercentage && (
            <div className="flex items-center mt-2">
              <span className={`text-sm font-medium ${getChangeColor(changeType)}`}>
                {change}
              </span>
            </div>
          )}
        </div>
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(color)}`}>
          <Icon name={icon} size={24} />
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;